import React, { useState } from 'react';
import { Form, Button, Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from "react-router-dom";

const AutoPaymentsReportForm = () => {
  const [formData, setFormData] = useState({
    values: '',
    filter: 'overdue',
    process: 'only-cards',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
  };

  return (
    <Container className="mt-4" style={{ maxWidth: '600px',marginLeft:"0px" }}>
      <Form onSubmit={handleSubmit} className="p-4 border rounded">
        <fieldset>
          <legend>Parameters</legend>

          {/* Base On Selection */}
          <Form.Group as={Row} controlId="values" className="mb-3">
            <Form.Label column sm="4" title="Please choose what values you want to base the report on">
              Base On
            </Form.Label>
            <Col sm="8">
              <Form.Control
                as="select"
                name="values"
                value={formData.values}
                onChange={handleChange}
                className="form-select"
                title="Please choose what values you want to base the report on"
              >
                <option value="">Money Owed</option>
                <option value="date">Date</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Filter Selection */}
          <Form.Group as={Row} controlId="filter" className="mb-3">
            <Form.Label column sm="4" title="Please choose a filter to limit the report">
              Filter <span className="text-danger">*</span>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                as="select"
                name="filter"
                value={formData.filter}
                onChange={handleChange}
                className="form-select"
                title="Please choose a filter to limit the report"
                required
              >
                <option value="">Live Totals</option>
                <option value="overdue">Live Totals - Overdue Only</option>
                <option value="statements">Last Statement</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Process Selection */}
          <Form.Group as={Row} controlId="process" className="mb-3">
            <Form.Label column sm="4" title="Choose how to process accounts">
              Process
            </Form.Label>
            <Col sm="8">
              <Form.Control
                as="select"
                name="process"
                value={formData.process}
                onChange={handleChange}
                className="form-select"
                title="Choose how to process accounts"
              >
                <option value="only-cards">Only Cards On File</option>
                <option value="all">All Accounts</option>
              </Form.Control>
            </Col>
          </Form.Group>

          {/* Submit Button */}
           <Form.Group as={Row}>
            <Col sm={{ span: 8, offset: 4 }}>
              <Link to="/Addpaymentprocess">
                <Button
                  id="pay-per-task-submit"
                  type="button"
                  variant="primary"
                  className="w-100 mt-2"
                  style={{
                    backgroundColor: '#004aad',
                    borderColor: '#004aad',
                    marginTop: '10px',
                  }}
                >
                  Run
                </Button>
              </Link>
            </Col>
          </Form.Group>
        </fieldset>
      </Form>
    </Container>
  );
};

export default AutoPaymentsReportForm;
